export default "__VITE_ASSET__Bkw5i8w4__"